import {HashRouter, Router} from 'react-router-dom'
import { createBrowserHistory } from "history";

import './Layout.css';
import Header from './Header';
import Routing from './Routing'
import {clearAll} from '../../../Helpers/Session';

function Layout (props){
  const history = createBrowserHistory();
  const logoutAction = () => {
    clearAll();
  }
  return (
    <Router history={history}>
      <div className="page"> 
        <Header logoutAction={logoutAction} companyDetails={props.companyDetails}/>
        <main className="main-content-area">
          <div className="container-fluid p-0">
            <div className="inner-container">
              <Routing/>                   
            </div>
          </div>
        </main>
      </div>
    </Router>
  );
}
export default Layout;